/** First-time multi-org login: show chooser until user confirms an organization. */
export const ORG_CHOICE_SESSION_KEY = 'cm_needs_org_choice';
